/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isactive1Inputs */

const en_entity_isactive1 = /** @type {(inputs: Entity_Isactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Active`)
};

const de_entity_isactive1 = /** @type {(inputs: Entity_Isactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist aktiv`)
};

/**
* | output |
* | --- |
* | "Is Active" |
*
* @param {Entity_Isactive1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isactive1 = /** @type {((inputs?: Entity_Isactive1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isactive1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isactive1(inputs)
	return de_entity_isactive1(inputs)
});
export { entity_isactive1 as "entity_isActive" }